export { postOrder, postOrderMany } from './ordersService';
